module.exports = __webpack_public_path__ + "static/img/20-3.a0382a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20-3.jpg
// module id = e//s
// module chunks = 0